<template v-if="state.tab === 0">
    <div class="pop_up_layer com_pop" style="display: block" @click="closeModal"></div>
    <div class="pop_up com_pop" style="display: block">
        <!-- <div class="pop_up flex_box com_pop" style="display: block"> -->
        <div class="pop_tit _flex">
            <p>{{ props.userInfo.name }} 회원 관리</p>
            <button class="close_btn icon_wrap" @click="closeModal">
                <img src="img/close.png" alt="닫기" />
            </button>
        </div>

        <div class="join sign_form custom_scroll">
            <ul>
                <li class="">
                    <label for="user_id" class="form_li_tit">아이디</label>
                    <input id="user_id" type="text" v-model="props.userInfo.id" disabled />
                </li>
                <li class="">
                    <label for="user_pw" class="form_li_tit">비밀번호</label>
                    <input id="user_pw" type="password" v-model="form_state.pw" placeholder="비밀번호를 입력하세요" />
                    <p class="p_info" v-if="!state.pwIsPossible">비밀번호는 문자, 숫자, 특수문자의 조합으로 8자 이상 입력해주세요.</p>
                </li>
                <li class="">
                    <label for="user_pw_chk" class="form_li_tit">비밀번호 확인</label>
                    <input id="user_pw_chk" type="password" v-model="form_state.pwConfirm" placeholder="비밀번호 확인" />
                    <p class="p_warn" v-if="state.pwIsPossible && form_state.pw !== form_state.pwConfirm">
                        *비밀번호가 일치하지 않습니다. 다시 입력해주세요.
                    </p>
                </li>
                <li class="">
                    <label for="name" class="form_li_tit">이름</label>
                    <input id="name" type="text" v-model="props.userInfo.name" disabled />
                </li>
                <li class="">
                    <label for="nickname" class="form_li_tit">닉네임</label>
                    <input id="nickname" type="text" v-model="props.data.nickname" placeholder="닉네임을 입력하세요" />
                </li>
                <li class="">
                    <label for="birthday" class="form_li_tit">생년월일</label>
                    <input id="birthday" type="text" v-model="props.data.birth" disabled />
                </li>
                <li class="checkbox_wrap">
                    <span class="form_li_tit">성별</span>
                    <label for="female">
                        <input id="female" name="gender" type="radio" value="F" v-model="props.data.gender" disabled />
                        <em></em>
                        <span>여자</span>
                    </label>
                    <label for="male">
                        <input id="male" name="gender" type="radio" value="M" v-model="props.data.gender" disabled />
                        <em></em>
                        <span>남자</span>
                    </label>
                    <label for="gender_etc">
                        <input id="gender_etc" name="gender" type="radio" value="E" v-model="props.data.gender" disabled />
                        <em></em>
                        <span>기타</span>
                    </label>
                </li>
                <li class="mail_wrap">
                    <label for="mail_01" class="form_li_tit">E-mail</label>
                    <input id="mail_01" type="text" placeholder="" :value="CommonUtils.convertEmail(props.data.email).id" disabled />

                    <em>@</em>
                    <input id="mail_02" type="text" placeholder="" :value="CommonUtils.convertEmail(props.data.email).domain" disabled />
                    <!-- <div class="select_tab_box">
                        <div class="selected_tab">
                            <span>직접입력</span>
                        </div>
                        <div class="tab_option">
                            <button>gmail.com</button>
                            <button>naver.com</button>
                            <button>daum.net</button>
                            <button class="self">직접입력</button>
                        </div>
                    </div> -->
                    <!-- <button class="blue_btn">중복확인</button> -->
                </li>
                <li class="phone_wrap">
                    <label for="user_ph1" class="form_li_tit">전화번호</label>
                    <input id="user_ph1" type="text" :value="CommonUtils.convertPhoneNum(props.data.phone).phoneNum1" disabled />
                    <em>-</em>
                    <input id="user_ph2" type="text" :value="CommonUtils.convertPhoneNum(props.data.phone).phoneNum2" disabled />
                    <em>-</em>
                    <input id="user_ph3" type="text" :value="CommonUtils.convertPhoneNum(props.data.phone).phoneNum3" disabled />
                </li>
                <li class="add_wrap">
                    <label for="zipcode" class="form_li_tit">주소</label>
                    <input
                        id="zipcode"
                        type="text"
                        class="code test"
                        placeholder="우편번호"
                        @click="searchAddress"
                        v-model="form_state.zipCode"
                        readonly
                    />
                    <button class="blue_btn" @click="searchAddress">검색</button>
                    <input id="address" type="text" class="need_space test" placeholder="기본주소" v-model="form_state.address" readonly />
                    <input id="addressDetail" type="text" class="need_space" placeholder="상세주소" v-model="form_state.addressDetail" />
                </li>
                <!-- <hr /> -->
                <li class="radio_wrap">
                    <span class="form_li_tit">등급</span>
                    <label for="grade111" class="checkbox_wrap2">
                        <input id="grade111" name="radioGrade" type="radio" :value="1" v-model="form_state.grade" @click="form_state.grade = 1" />
                        <em></em>
                        <span>일반</span>
                    </label>
                    <label for="grade222" class="checkbox_wrap2">
                        <input id="grade222" name="radioGrade" type="radio" :value="2" v-model="form_state.grade" @click="form_state.grade = 2" />
                        <em></em>
                        <span>활동 선정자</span>
                    </label>
                </li>

                <li class="join_way_wrap checkbox_wrap">
                    <span class="form_li_tit">가입경로</span>
                    <label for="join_way1">
                        <input id="join_way1" name="join_way" value="1" v-model="props.data.location" type="radio" disabled />
                        <em></em>
                        <span>다시함께상담센터 홈페이지</span>
                    </label>
                    <label for="join_way2">
                        <input id="join_way2" name="join_way" value="2" v-model="props.data.location" type="radio" disabled />
                        <em></em>
                        <span>포털사이트 검색(네이버, 구글 등)</span>
                    </label>
                    <label for="join_way3" class="need_space">
                        <input id="join_way3" name="join_way" value="3" v-model="props.data.location" type="radio" disabled />
                        <em></em>
                        <span>SNS(X (구.트위터), 인스타그램 등)</span>
                    </label>
                    <label for="join_way5">
                        <input id="join_way5" name="join_way" value="4" v-model="props.data.location" type="radio" disabled />
                        <em></em>
                        <span>지인추천</span>
                    </label>
                    <label for="join_way6">
                        <input id="join_way6" name="join_way" value="5" v-model="props.data.location" type="radio" disabled />
                        <em></em>
                        <span>기타</span>
                        <input
                            type="text"
                            v-if="props.data.location === 5"
                            v-model="props.data.locationDetail"
                            disabled
                            placeholder="예: 커뮤니티, 대학교 게시판"
                        />
                    </label>
                </li>
                <li class="checkbox_wrap">
                    <span class="form_li_tit">정보제공 동의</span>
                    <label for="mail_agree">
                        <input id="mail_agree" type="checkbox" disabled :checked="props.data.isSupply" />
                        <em></em>
                        <span class="no_blue">동의</span>
                    </label>
                </li>
                <li class="_flex _half">
                    <div>
                        <span class="form_li_tit">회원가입일</span>
                        <span>{{ CommonUtils.dateFormat(new Date(props.userInfo.createDate), ".", true) }}</span>
                    </div>
                    <div>
                        <span class="form_li_tit">최근접속일</span>
                        <span>
                            {{ props.userInfo?.loginDate ? CommonUtils.dateFormat(new Date(props.userInfo.loginDate), ".", true) : "-" }}
                        </span>
                    </div>
                </li>
                <!-- <li class="checkbox_wrap">
                    <span class="form_li_tit">본인인증</span>
                    <label for="self_chk">
                        <input id="self_chk" type="checkbox" checked disabled />
                        <em></em>
                    </label>
                </li> -->
                <!-- <li class="checkbox_wrap">
                    <span class="form_li_tit">전자서명</span>
                    <label for="e_sign">
                        <input id="e_sign" type="checkbox" checked disabled />
                        <em></em>
                        <button type="button" class="download table_btn _blue">다운로드</button>
                    </label>
                </li> -->
            </ul>
        </div>
        <div class="_flex _center btn_wrap">
            <button class="submit_btn _130 _gray" @click="closeModal">취소</button>
            <button class="submit_btn _130 _main_blue" @click="modifyForMember">정보수정</button>
        </div>
    </div>
</template>
<script lang="ts">
    import { onMounted, reactive, watch, onUnmounted, CommonUtils, apiService, types, getMessageByCode } from "@/BaseComponent";

    export default {
        props: {
            idx: {
                type: Number,
                default: 0,
            },
            data: {
                type: Object,
                defalut: {},
            },
            userInfo: {
                type: Object,
                defalut: {},
            },
        },
        emits: ["close", "modifyForMember"],
        setup(props: any, { emit }: any) {
            const state = reactive({
                idx: 0 as number,
                data: {} as any,

                isShowModal: false as boolean,
                modalTab: -1 as number,

                pwIsPossible: false,
                pwReCheck: false,
            });

            const form_state = reactive({
                pw: "",
                pwConfirm: "",
                zipCode: props.data.zipCode,
                address: props.data.addr,
                addressDetail: props.data.addrDetail,
                nickName: props.data.nickname,
                isLeave: 0,
                isBlock: 0,
                grade: 1 as number,
            });

            onMounted(() => {});

            watch(
                () => props.data,
                (newData) => {
                    form_state.zipCode = newData.zipCode;
                    form_state.address = newData.addr;
                    form_state.addressDetail = newData.addrDetail;
                    form_state.nickName = newData.nickname;
                    form_state.grade = newData.grade;
                },
                { immediate: true, deep: true },
            );

            watch(
                () => form_state.pw,
                (newVal) => (state.pwIsPossible = CommonUtils.regexForPassword.test(newVal)),
            );
            watch(
                () => [form_state.pw, form_state.pwConfirm],
                () => {
                    state.pwReCheck = state.pwIsPossible && form_state.pw === form_state.pwConfirm;
                },
            );

            onUnmounted(() => {});

            const closeModal = () => emit("close");

            const save = () => {
                // emit("save", state.data.memo);
            };

            const modifyForMember = () => {
                const param: types.ReqUserForModifyForAdmin = {
                    idx: props.data.idx,
                    pw: form_state.pw,
                    pwReCheck: state.pwReCheck,
                    zipCode: form_state.zipCode,
                    address: form_state.address,
                    addressDetail: form_state.addressDetail,
                    nickName: form_state.nickName,
                    isLeave: props.data.isLeave,
                    isBlock: 0,
                    grade: form_state.grade,
                };
                emit("modifyForMember", props.data.idx, param);
            };

            const searchAddress = async () => {
                new window.daum.Postcode({
                    oncomplete: (data: any) => {
                        form_state.zipCode = data.zonecode; // 우편번호
                        form_state.address = data.address; // 전체 주소
                    },
                }).open();
            };

            return { state, form_state, closeModal, props, CommonUtils, save, modifyForMember, searchAddress };
        },
    };
</script>
<style>
    .test {
        background-color: #f5f5f5 !important;
    }
</style>
<style scoped>
    .pop_up.com_pop {
        height: 100%;
    }
    .join.sign_form.custom_scroll {
        height: 85%;
    }
</style>
